import React from "react"
import ReactDOM from "react-dom"
import { BrowserRouter } from "react-router-dom"
import App from "./App"
import { AuthContextProvider } from "./context/AuthContext"
import { ChallengeContextProvider } from "./context/ChallengeContext"
import { IndividualContextProvider } from "./context/IndividualContext"
import "./index.css"
import reportWebVitals from "./reportWebVitals"

ReactDOM.render(
  <React.StrictMode>
    <AuthContextProvider>
      <ChallengeContextProvider>
        <IndividualContextProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </IndividualContextProvider>
      </ChallengeContextProvider>
    </AuthContextProvider>
  </React.StrictMode>,
  document.getElementById("root"),
)

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals()
